import { Component, Vue } from 'vue-property-decorator';
import { Role } from '@/core/interfaces/role';

@Component
export default class TranslatesRole extends Vue {
    public translateRole(role: Role): string {
        return this.$t(`roles.${role.code_name}`).toString();
    }
}
